import { Directive, OnDestroy, OnInit, Optional, TemplateRef, ViewContainerRef } from '@angular/core';
import { CentralNavigationService } from '../services/central-navigation.service';

@Directive({selector:'ng-template[appCentralChildNav]'})
export class CentralChildNavigationDirective implements OnInit, OnDestroy {
    constructor(private template:TemplateRef<unknown>, @Optional() private navigation:CentralNavigationService,
        private container:ViewContainerRef){}
    ngOnInit():void {
        if(this.navigation){this.navigation.show(this.template);}else{this.container.createEmbeddedView(this.template);}
    }
    ngOnDestroy():void { this.navigation?.clear(this.template); }
}
